import { BLUE_20, BLUE_40, GREY_20, ORANGE_20, ORANGE_40 } from '@lib/colors';

import { IScoreScale, IScoreScaleColors, IScoreScaleRange, ScoreScaleClassType } from './safety-score.interface';

export enum SCORE_SCALE_TYPE {
  EXCELLENT = 'excellent',
  GOOD = 'good',
  FAIR = 'fair',
  POOR = 'poor',
  VERY_POOR = 'very_poor',
  ALL_SCORES = 'all_scores',
}

export const MAX_SCORE_RANGE_TEXT_LENGTH: number = 20;

export const SCORE_SCALE: IScoreScale = {
  EXCELLENT: 70,
  GOOD: 55,
  FAIR: 50,
  POOR: 40,
  VERY_POOR: 0,
};

export const SCORE_SCALE_COLORS: IScoreScaleColors = {
  EXCELLENT: BLUE_40,
  GOOD: BLUE_20,
  FAIR: GREY_20,
  POOR: ORANGE_20,
  VERY_POOR: ORANGE_40,
};

export const SAFETY_SCORE_RANGE: IScoreScaleRange = {
  EXCELLENT: {
    start_score: SCORE_SCALE.EXCELLENT,
    end_score: 100,
  },
  GOOD: {
    start_score: SCORE_SCALE.GOOD,
    end_score: SCORE_SCALE.EXCELLENT - 1,
  },
  FAIR: {
    start_score: SCORE_SCALE.FAIR,
    end_score: SCORE_SCALE.GOOD - 1,
  },
  POOR: {
    start_score: SCORE_SCALE.POOR,
    end_score: SCORE_SCALE.FAIR - 1,
  },
  VERY_POOR: {
    start_score: SCORE_SCALE.VERY_POOR + 1,
    end_score: SCORE_SCALE.POOR - 1,
  },
  ALL_SCORES: {
    start_score: SCORE_SCALE.VERY_POOR,
    end_score: 100,
  },
};

export const SERVER_SCORE_SCALE: Partial<Record<SCORE_SCALE_TYPE, ScoreScaleClassType>> = {
  [SCORE_SCALE_TYPE.EXCELLENT]: 'safety-score-excellent',
  [SCORE_SCALE_TYPE.GOOD]: 'safety-score-good',
  [SCORE_SCALE_TYPE.FAIR]: 'safety-score-fair',
};

export const SERVER_SCORE_LABEL: Partial<Record<SCORE_SCALE_TYPE, string>> = {
  [SCORE_SCALE_TYPE.EXCELLENT]: $localize`excellent`,
  [SCORE_SCALE_TYPE.GOOD]: $localize`good`,
  [SCORE_SCALE_TYPE.FAIR]: $localize`fair`,
};